require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-twitter-ifttt-test.json") })
        }
      }, "path---post-twitter-ifttt-test");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-twitter-ifttt-test!./.cache/json/post-twitter-ifttt-test.json
// module id = 360
// module chunks = 231608221292675